import { ThemeProvider, ToastProvider } from '@hopex/ui';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './router.tsx';
import { AdminSessionProvider } from './session.tsx';
import './styles.css';

// After a deploy, a tab opened on the previous build can ask for a code piece that no longer exists:
// reload once onto the new build instead of failing (at most once per 30 s; no storage → no reload).
window.addEventListener('vite:preloadError', (e) => {
  try {
    const last = Number(window.sessionStorage.getItem('hx-reloaded-at') ?? '0');
    if (Date.now() - last < 30_000) return;
    window.sessionStorage.setItem('hx-reloaded-at', String(Date.now()));
  } catch {
    return;
  }
  e.preventDefault();
  window.location.reload();
});

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <AdminSessionProvider>
          <RouterProvider router={router} />
        </AdminSessionProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
